import types from './types';

const initialState = {
  advertiserName: null,
  advertiserEmailAddress: null,
  isFetching: false,
  isPaymentSuccessful: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ADVERTISER_NAME:
      return {
        ...state,
        advertiserName: action.payload,
      };
    case types.SET_IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload,
      };
    case types.SET_IS_PAYMENT_SUCCESSFUL:
      return {
        ...state,
        isPaymentSuccessful: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
